import { render, staticRenderFns } from "./BForm.vue?vue&type=template&id=060d43ae&"
import script from "./BForm.vue?vue&type=script&lang=js&"
export * from "./BForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports